
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k9TfW", function(module, exports) {
/**
 * @generated SignedSource<<85851f6331fdff74b3338b14e05b8616>>
 * @relayHash e8ab1aa41f56a8e58f4647aa87445304
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44d71eb1075e55c9e8988db704ccfc0b6109617afe7632d2d7fe5937068a9f7a
const $aa2df423f4e2632a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchPresenceAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchPresenceAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e8ab1aa41f56a8e58f4647aa87445304",
            "id": "44d71eb1075e55c9e8988db704ccfc0b6109617afe7632d2d7fe5937068a9f7a",
            "metadata": {},
            "name": "fetchPresenceAGGUsersQuery",
            "operationKind": "query",
            "text": "query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,name,picture,id}}"
        }
    };
}();
$aa2df423f4e2632a$var$node.hash = "57d1e29c802c13d5478283a266661ce1";
var $aa2df423f4e2632a$export$2e2bcd8739ae039 = $aa2df423f4e2632a$var$node;



var $c0rhi = parcelRequire("c0rhi");

const $aed2f5bf61ddaaa1$export$9db34321b84dd37a = (accountIds)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $aa2df423f4e2632a$export$2e2bcd8739ae039),
        variables: {
            accountIds: accountIds
        },
        interopApolloAggClient: true,
        __callerPackage__: "team-presence"
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId || ''
            })) ?? [];
    });
};
module.exports["fetchPresenceAGGUsers"] = $aed2f5bf61ddaaa1$export$9db34321b84dd37a;

});

parcelRegister("iwQHw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $a2bT0 = parcelRequire("a2bT0");


var $ji12t = parcelRequire("ji12t");


var $2yWJZ = parcelRequire("2yWJZ");


var $d6Ahp = parcelRequire("d6Ahp");


var $3EM6l = parcelRequire("3EM6l");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $gk8Zi = parcelRequire("gk8Zi");




/**
 * @generated SignedSource<<6f47ad89c0db6b94e62d63adfa2553f8>>
 * @relayHash f5c717e923bf00b11aaaea19cf66c689
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dafa511b8390ff5efc8841fc0285b2f3680e5c85163429e75d63d002faa5ff5
const $6092839986de16c7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentIdentityAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "avatarRelay_user"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentIdentityAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5c717e923bf00b11aaaea19cf66c689",
            "id": "8dafa511b8390ff5efc8841fc0285b2f3680e5c85163429e75d63d002faa5ff5",
            "metadata": {},
            "name": "AgentIdentityAvatarQuery",
            "operationKind": "query",
            "text": "query AgentIdentityAvatarQuery($accountId:ID!){user(accountId:$accountId){__typename,picture,...avatarRelay_user,id}}fragment avatarRelay_user on User{__isUser:__typename,picture,...on AppUser{appType}}"
        }
    };
}();
$6092839986de16c7$var$node.hash = "bc56858ea415054ebfcd1ab9f95ed2b4";
var $6092839986de16c7$export$2e2bcd8739ae039 = $6092839986de16c7$var$node;






var $6SsN4 = parcelRequire("6SsN4");








var $ddpUU = parcelRequire("ddpUU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5ZqQS = parcelRequire("5ZqQS");


var $hvS6g = parcelRequire("hvS6g");













const $94a460bb489bf561$var$styles = {
    root: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _1mT5xdRAKS",
    blockRoot: "_3iDTPbQ4SZ",
    small: "_39xV02oWWg _0jFU0VL7Tg",
    medium: "_39xV02Uofl _0jFU0VrIqH",
    overlapped: "_0GTcwRTUhv"
};
function $94a460bb489bf561$export$353dd457f40f0ab(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { children: children, size: size, isBlock: isBlock, isOverlapped: isOverlapped, stackIndex: stackIndex, onLoadCapture: onLoadCapture, onErrorCapture: onErrorCapture, testId: t1 } = t0;
    const testId = t1 === undefined ? "agent-presence-avatar" : t1;
    let t2;
    if ($[0] !== stackIndex) {
        t2 = {
            zIndex: stackIndex
        };
        $[0] = stackIndex;
        $[1] = t2;
    } else t2 = $[1];
    const style = t2;
    const t3 = size && $94a460bb489bf561$var$styles.root;
    const t4 = isBlock && $94a460bb489bf561$var$styles.blockRoot;
    const t5 = size && $94a460bb489bf561$var$styles[size];
    const t6 = isOverlapped && $94a460bb489bf561$var$styles.overlapped;
    let t7;
    if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
        t7 = (0, $w6R6I.cx)(t3, t4, t5, t6);
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== children || $[8] !== onErrorCapture || $[9] !== onLoadCapture || $[10] !== style || $[11] !== t7 || $[12] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t7,
            style: style,
            onLoadCapture: onLoadCapture,
            onErrorCapture: onErrorCapture,
            testId: testId
        }, children);
        $[7] = children;
        $[8] = onErrorCapture;
        $[9] = onLoadCapture;
        $[10] = style;
        $[11] = t7;
        $[12] = testId;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
}


const $be7e146022965c51$var$styles = {
    picture: "_3iDTPbccYA _3YEZNOdnbC",
    hidden: "_0fKRyPnQyn"
};
function $be7e146022965c51$var$IdentityAvatar(t0) {
    const $ = (0, $bDgLe.c)(13);
    let accountId;
    let props;
    if ($[0] !== t0) {
        ({ accountId: accountId, ...props } = t0);
        $[0] = t0;
        $[1] = accountId;
        $[2] = props;
    } else {
        accountId = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== accountId) {
        t1 = {
            accountId: accountId
        };
        $[3] = accountId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[5] = t2;
    } else t2 = $[5];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $6092839986de16c7$export$2e2bcd8739ae039), t1, t2);
    const t3 = data.user?.picture;
    let t4;
    if ($[6] !== data.user?.picture) {
        t4 = data.user?.picture?.trim();
        $[6] = data.user?.picture;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = Boolean(t4);
    let t6;
    if ($[8] !== data.user || $[9] !== props || $[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be7e146022965c51$var$IdentityPicture, {
            key: t3,
            ...props,
            hasPicture: t5,
            userFragment: data.user
        });
        $[8] = data.user;
        $[9] = props;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
}
function $be7e146022965c51$var$IdentityPicture(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { userFragment: userFragment, hasPicture: hasPicture, name: name, size: size, showBorder: showBorder } = t0;
    const [isImageLoading, setIsImageLoading] = (0, $cozmU.useState)(hasPicture);
    const hasReportedImageFailure = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsImageLoading(false);
        $[0] = t1;
    } else t1 = $[0];
    const handleLoad = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsImageLoading(false);
            if (!hasReportedImageFailure.current) {
                hasReportedImageFailure.current = true;
                (0, $5ZqQS.getMonitoringClient)().incrementCounter("agentPresence.identityAvatarFallback", [
                    "reason:imageLoadFailed",
                    `attribution:${(0, $3IBnw.Attribution).COLLABORATION_PRESENCE}`
                ]);
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleError = t2;
    const t3 = isImageLoading && $be7e146022965c51$var$styles.hidden;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $w6R6I.cx)($be7e146022965c51$var$styles.picture, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = isImageLoading || undefined;
    const t6 = showBorder ? "var(--ds-surface, #FFFFFF)" : "transparent";
    let t7;
    if ($[4] !== name || $[5] !== size || $[6] !== t6 || $[7] !== userFragment) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddpUU.AvatarRelay), {
            userFragment: userFragment,
            name: name,
            label: name,
            size: size,
            borderColor: t6,
            UNSAFE_isUpdatedGeometry: true,
            imgLoading: "eager",
            testId: "agent-presence-identity-avatar"
        });
        $[4] = name;
        $[5] = size;
        $[6] = t6;
        $[7] = userFragment;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4,
            "aria-hidden": t5,
            onLoadCapture: handleLoad,
            onErrorCapture: handleError,
            testId: "agent-presence-identity-picture"
        }, t7);
        $[9] = t4;
        $[10] = t5;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
}
function $be7e146022965c51$export$34c5d91771d01278(t0) {
    const $ = (0, $bDgLe.c)(14);
    let isOverlapped;
    let props;
    let stackIndex;
    if ($[0] !== t0) {
        ({ stackIndex: stackIndex, isOverlapped: isOverlapped, ...props } = t0);
        $[0] = t0;
        $[1] = isOverlapped;
        $[2] = props;
        $[3] = stackIndex;
    } else {
        isOverlapped = $[1];
        props = $[2];
        stackIndex = $[3];
    }
    let t1;
    if ($[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
            fallback: null,
            interactionName: "AgentIdentityAvatarQuery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be7e146022965c51$var$IdentityAvatar, props));
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== props.accountId || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            key: props.accountId,
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE,
            renderOnError: $be7e146022965c51$var$_temp
        }, t1);
        $[6] = props.accountId;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== isOverlapped || $[10] !== props.size || $[11] !== stackIndex || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94a460bb489bf561$export$353dd457f40f0ab), {
            size: props.size,
            stackIndex: stackIndex,
            isOverlapped: isOverlapped
        }, t2);
        $[9] = isOverlapped;
        $[10] = props.size;
        $[11] = stackIndex;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
}
function $be7e146022965c51$var$_temp() {
    return null;
}



const $82c5dbca758f5691$var$AGENT_AVATAR_SHELL_BORDER_WIDTH = 1;
const $82c5dbca758f5691$var$styles = {
    avatarContent: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS",
    shell: "_3iDTPbvLZJ _1mT5xdWVPG _3OE6xY715P _1pp6NdYbGa",
    legacyBorder: "_1mT5xdRAKS _1llTr68BLF"
};
const $82c5dbca758f5691$var$AgentAvatarShell = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { backgroundColor: backgroundColor, borderColor: borderColor, size: size } = t0;
    const { width: width, height: height } = (0, $gk8Zi.AGENT_AVATAR_SHELL_SIZE)[size];
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            top: "0.2px",
            transform: "translateX(-50%) rotate(0deg)",
            opacity: 1
        };
        $[0] = t1;
    } else t1 = $[0];
    const t2 = (0, $gk8Zi.AGENT_AVATAR_SHELL_VIEWBOX)[size];
    const t3 = size === "small" ? "visible" : undefined;
    const t4 = (0, $gk8Zi.AGENT_AVATAR_SHELL_PATH)[size];
    let t5;
    if ($[1] !== backgroundColor || $[2] !== borderColor || $[3] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-testid": "agent-presence-avatar-shell-shape",
            d: t4,
            fill: backgroundColor,
            stroke: borderColor,
            strokeWidth: $82c5dbca758f5691$var$AGENT_AVATAR_SHELL_BORDER_WIDTH,
            vectorEffect: "non-scaling-stroke"
        });
        $[1] = backgroundColor;
        $[2] = borderColor;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== height || $[6] !== t2 || $[7] !== t3 || $[8] !== t5 || $[9] !== width) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.shell,
            style: t1,
            testId: "agent-presence-avatar-shell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            "data-testid": "agent-presence-avatar-shell-svg",
            display: "block",
            width: width,
            height: height,
            viewBox: t2,
            overflow: t3,
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            focusable: "false"
        }, t5));
        $[5] = height;
        $[6] = t2;
        $[7] = t3;
        $[8] = t5;
        $[9] = width;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
const $82c5dbca758f5691$var$getShellColors = (agent, borderColor)=>{
    const { primary: primary } = (0, $a2bT0.getAgentAvatarColor)({
        agentIdentityAccountId: agent.identity_account_id,
        agentId: agent.id,
        agentNamedId: agent.external_config_reference ?? agent.named_id
    });
    return {
        backgroundColor: primary,
        borderColor: borderColor ?? primary
    };
};
const $82c5dbca758f5691$var$isNormallyWhiteBrand = (agentIcon)=>{
    switch(agentIcon){
        case 'antigravity':
        case 'codex':
        case 'gemini':
        case 'hermes':
        case 'microsoft-copilot':
        case 'vscode':
            return true;
        default:
            return false;
    }
};
function $82c5dbca758f5691$export$1233303c82069087(t0) {
    const $ = (0, $bDgLe.c)(79);
    const { agent: agent, isOverlapped: isOverlapped, stackIndex: stackIndex, showBorder: showBorder, size: t1 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const colorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    let isAgentPresenceMoveEnabled = false;
    if ((0, $9wGTI.fg)("platform_move_presence_agents")) isAgentPresenceMoveEnabled = true;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = isAgentPresenceMoveEnabled && (0, $9wGTI.fg)("confluence_refined_agent_presence_geometries");
        $[0] = t2;
    } else t2 = $[0];
    const isRefinedGeometryEnabled = t2;
    const isFacepileAvatar = isRefinedGeometryEnabled && stackIndex !== undefined;
    let t3;
    if ($[1] !== agent.agentIcon || $[2] !== isFacepileAvatar) {
        t3 = isFacepileAvatar && (!agent.agentIcon || agent.agentIcon === "open-code" || !(0, $6mKj3.expValEquals)("agentic_presence_facepile_master_exp", "isEnabled", true));
        $[1] = agent.agentIcon;
        $[2] = isFacepileAvatar;
        $[3] = t3;
    } else t3 = $[3];
    const usesSharedFacepileOutline = t3;
    const showArtworkOutline = !usesSharedFacepileOutline && (!isFacepileAvatar || Boolean(showBorder));
    let t4;
    if ($[4] !== isFacepileAvatar || $[5] !== size) {
        t4 = isFacepileAvatar && size === "small" && (0, $6mKj3.expValEquals)("agentic_presence_facepile_master_exp", "isEnabled", true);
        $[4] = isFacepileAvatar;
        $[5] = size;
        $[6] = t4;
    } else t4 = $[6];
    const usesSquareFacepileViewport = t4;
    let t5;
    if ($[7] !== agent.agentIcon) {
        t5 = $82c5dbca758f5691$var$isNormallyWhiteBrand(agent.agentIcon);
        $[7] = agent.agentIcon;
        $[8] = t5;
    } else t5 = $[8];
    const isWhiteBrand = t5;
    const centerStrokeColor = isRefinedGeometryEnabled && colorMode === "light" && isWhiteBrand ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined;
    let t6;
    if ($[9] !== centerStrokeColor || $[10] !== showArtworkOutline || $[11] !== size || $[12] !== usesSquareFacepileViewport) {
        t6 = isRefinedGeometryEnabled ? {
            width: showArtworkOutline ? 2 : 0,
            svgHeight: usesSquareFacepileViewport ? 24 : size === "small" ? 27 : 36,
            centerStrokeColor: centerStrokeColor,
            centerStrokeWidth: centerStrokeColor ? 1 : undefined
        } : undefined;
        $[9] = centerStrokeColor;
        $[10] = showArtworkOutline;
        $[11] = size;
        $[12] = usesSquareFacepileViewport;
        $[13] = t6;
    } else t6 = $[13];
    const presenceOutline = t6;
    if (!agent.agentIcon && agent.isExternalAgentFallback === false && (0, $6mKj3.expValEquals)("cc_identity_branded_agent_attribution", "isEnabled", true)) {
        const t7 = showBorder ? size : undefined;
        const t8 = showBorder ? "var(--ds-surface, #FFFFFF)" : "transparent";
        let t9;
        if ($[14] !== agent.avatarUrl || $[15] !== agent.name || $[16] !== size || $[17] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "hexagon",
                borderColor: t8,
                name: agent.name,
                src: agent.avatarUrl,
                size: size,
                UNSAFE_isUpdatedGeometry: true,
                testId: "identity-agent-avatar"
            });
            $[14] = agent.avatarUrl;
            $[15] = agent.name;
            $[16] = size;
            $[17] = t8;
            $[18] = t9;
        } else t9 = $[18];
        let t10;
        if ($[19] !== isOverlapped || $[20] !== stackIndex || $[21] !== t7 || $[22] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94a460bb489bf561$export$353dd457f40f0ab), {
                size: t7,
                isOverlapped: isOverlapped,
                stackIndex: stackIndex
            }, t9);
            $[19] = isOverlapped;
            $[20] = stackIndex;
            $[21] = t7;
            $[22] = t9;
            $[23] = t10;
        } else t10 = $[23];
        return t10;
    }
    let t7;
    if ($[24] !== agent) {
        t7 = (avatarSize, presenceArtwork)=>agent.agentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
                name: agent.name,
                agentIcon: agent.agentIcon,
                avatarSize: avatarSize,
                hasInlineSpacing: false,
                colorMode: presenceArtwork?.colorMode,
                borderColor: presenceArtwork?.borderColor,
                presenceTileFill: presenceArtwork?.presenceTileFill,
                presenceOutline: presenceArtwork?.presenceOutline,
                usePresenceArtwork: presenceArtwork ? true : undefined
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                key: agent.id,
                imageUrl: agent.avatarUrl,
                agentId: agent.id,
                agentIdentityAccountId: agent.identity_account_id,
                agentNamedId: agent.external_config_reference ?? agent.named_id,
                size: avatarSize,
                showBorder: false,
                isForgeAgent: (0, $ji12t.isForgeAgent)(agent),
                forgeAgentIconUrl: agent.icon
            });
        $[24] = agent;
        $[25] = t7;
    } else t7 = $[25];
    const renderAgentAvatar = t7;
    if (!isAgentPresenceMoveEnabled) {
        const t8 = showBorder && $82c5dbca758f5691$var$styles.legacyBorder;
        let t9;
        if ($[26] !== t8) {
            t9 = (0, $w6R6I.cx)(t8);
            $[26] = t8;
            $[27] = t9;
        } else t9 = $[27];
        let t10;
        if ($[28] !== stackIndex) {
            t10 = {
                zIndex: stackIndex
            };
            $[28] = stackIndex;
            $[29] = t10;
        } else t10 = $[29];
        let t11;
        if ($[30] !== renderAgentAvatar) {
            t11 = renderAgentAvatar("medium");
            $[30] = renderAgentAvatar;
            $[31] = t11;
        } else t11 = $[31];
        let t12;
        if ($[32] !== t10 || $[33] !== t11 || $[34] !== t9) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t9,
                style: t10
            }, t11);
            $[32] = t10;
            $[33] = t11;
            $[34] = t9;
            $[35] = t12;
        } else t12 = $[35];
        return t12;
    }
    let t8;
    if ($[36] !== agent.identity_account_id) {
        t8 = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(agent.identity_account_id);
        $[36] = agent.identity_account_id;
        $[37] = t8;
    } else t8 = $[37];
    const accountId = t8;
    if (isFacepileAvatar && !agent.agentIcon && !agent.is_default && accountId && (0, $6mKj3.expValEquals)("agentic_presence_facepile_master_exp", "isEnabled", true) && (0, $9wGTI.fg)("cc_editor_agent_presence_patch_1")) {
        let t9;
        if ($[38] !== accountId || $[39] !== agent.name || $[40] !== isOverlapped || $[41] !== showBorder || $[42] !== size || $[43] !== stackIndex) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $be7e146022965c51$export$34c5d91771d01278), {
                accountId: accountId,
                name: agent.name,
                size: size,
                showBorder: showBorder,
                stackIndex: stackIndex,
                isOverlapped: isOverlapped
            });
            $[38] = accountId;
            $[39] = agent.name;
            $[40] = isOverlapped;
            $[41] = showBorder;
            $[42] = size;
            $[43] = stackIndex;
            $[44] = t9;
        } else t9 = $[44];
        return t9;
    }
    const avatarSize_0 = size;
    let shellColors;
    let t9;
    if ($[45] !== agent || $[46] !== avatarSize_0 || $[47] !== colorMode || $[48] !== isWhiteBrand || $[49] !== presenceOutline || $[50] !== renderAgentAvatar || $[51] !== showArtworkOutline || $[52] !== showBorder || $[53] !== usesSharedFacepileOutline) {
        let presenceArtwork_0;
        if (isRefinedGeometryEnabled) {
            const borderColor = showArtworkOutline ? "var(--ds-surface, #FFFFFF)" : "transparent";
            const presenceTileFill = colorMode === "dark" && isWhiteBrand ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined;
            presenceArtwork_0 = {
                borderColor: borderColor,
                colorMode: colorMode,
                presenceTileFill: presenceTileFill,
                presenceOutline: presenceOutline
            };
        }
        const shellBorderColor = usesSharedFacepileOutline ? "transparent" : isRefinedGeometryEnabled ? colorMode === "dark" ? "transparent" : "var(--ds-surface, #FFFFFF)" : undefined;
        let t10;
        if ($[56] !== agent || $[57] !== shellBorderColor || $[58] !== showBorder) {
            t10 = showBorder && !agent.agentIcon ? $82c5dbca758f5691$var$getShellColors(agent, shellBorderColor) : undefined;
            $[56] = agent;
            $[57] = shellBorderColor;
            $[58] = showBorder;
            $[59] = t10;
        } else t10 = $[59];
        shellColors = t10;
        t9 = renderAgentAvatar(avatarSize_0, presenceArtwork_0);
        $[45] = agent;
        $[46] = avatarSize_0;
        $[47] = colorMode;
        $[48] = isWhiteBrand;
        $[49] = presenceOutline;
        $[50] = renderAgentAvatar;
        $[51] = showArtworkOutline;
        $[52] = showBorder;
        $[53] = usesSharedFacepileOutline;
        $[54] = shellColors;
        $[55] = t9;
    } else {
        shellColors = $[54];
        t9 = $[55];
    }
    const agentAvatar = t9;
    const t10 = showBorder ? avatarSize_0 : undefined;
    let t11;
    if ($[60] !== showBorder) {
        t11 = showBorder && (0, $9wGTI.fg)("confluence_neutral_human_presence_avatars");
        $[60] = showBorder;
        $[61] = t11;
    } else t11 = $[61];
    let t12;
    if ($[62] !== avatarSize_0 || $[63] !== showBorder || $[64] !== usesSharedFacepileOutline) {
        t12 = showBorder && usesSharedFacepileOutline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk8Zi.AgentPresenceOutline), {
            color: "var(--ds-surface, #FFFFFF)",
            size: avatarSize_0
        }) : null;
        $[62] = avatarSize_0;
        $[63] = showBorder;
        $[64] = usesSharedFacepileOutline;
        $[65] = t12;
    } else t12 = $[65];
    let t13;
    if ($[66] !== agentAvatar || $[67] !== avatarSize_0 || $[68] !== shellColors || $[69] !== showBorder || $[70] !== usesSharedFacepileOutline) {
        t13 = showBorder && shellColors ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82c5dbca758f5691$var$AgentAvatarShell, {
            ...shellColors,
            size: avatarSize_0
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.avatarContent
        }, agentAvatar)) : usesSharedFacepileOutline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.avatarContent
        }, agentAvatar) : agentAvatar;
        $[66] = agentAvatar;
        $[67] = avatarSize_0;
        $[68] = shellColors;
        $[69] = showBorder;
        $[70] = usesSharedFacepileOutline;
        $[71] = t13;
    } else t13 = $[71];
    let t14;
    if ($[72] !== isOverlapped || $[73] !== stackIndex || $[74] !== t10 || $[75] !== t11 || $[76] !== t12 || $[77] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94a460bb489bf561$export$353dd457f40f0ab), {
            size: t10,
            isBlock: t11,
            isOverlapped: isOverlapped,
            stackIndex: stackIndex
        }, t12, t13);
        $[72] = isOverlapped;
        $[73] = stackIndex;
        $[74] = t10;
        $[75] = t11;
        $[76] = t12;
        $[77] = t13;
        $[78] = t14;
    } else t14 = $[78];
    return t14;
}
module.exports["AgentPresenceAvatar"] = $82c5dbca758f5691$export$1233303c82069087;

});

parcelRegister("gk8Zi", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jeQ2h = parcelRequire("jeQ2h");

const $71771e95bc58fd84$export$d825e67f4012c870 = {
    small: {
        width: 23.11,
        height: 25.76
    },
    medium: {
        width: 32,
        height: 35
    }
};
const $71771e95bc58fd84$export$ce24d36f8c4f7527 = {
    // The updated path starts at (2, 2); keep its native 23.11 × 25.76 dimensions.
    small: '2 2 23.11 25.76',
    medium: '0 0 32 35'
};
const $71771e95bc58fd84$export$505240e540ebe25 = {
    small: (0, $jeQ2h.UPDATED_PRESENCE_HEX_GEOMETRY)[24].hex,
    medium: 'M 13.33 1.46 A 5 5 0 0 1 18.67 1.46 L 29.34 7.29 A 5 5 0 0 1 32 11.66 L 32 23.34 A 5 5 0 0 1 29.34 27.71 L 18.67 33.54 A 5 5 0 0 1 13.33 33.54 L 2.66 27.71 A 5 5 0 0 1 0 23.34 L 0 11.66 A 5 5 0 0 1 2.66 7.29 Z'
};
const $71771e95bc58fd84$var$OUTLINE_WIDTH = 2;
const $71771e95bc58fd84$var$styles = {
    root: "_1mT5xdWVPG _3OE6xY715P _1VJPcajssS _1pp6NdYbGa _42Yu6BdnbC"
};
const $71771e95bc58fd84$export$8b63d3e9f6d12780 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { color: color, size: size, testId: t1 } = t0;
    const testId = t1 === undefined ? "agent-presence-outline" : t1;
    const { width: width, height: height } = $71771e95bc58fd84$export$d825e67f4012c870[size];
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            top: "0.2px"
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $71771e95bc58fd84$var$styles.root
        ]);
        $[1] = t3;
    } else t3 = $[1];
    const t4 = $71771e95bc58fd84$export$ce24d36f8c4f7527[size];
    const t5 = $71771e95bc58fd84$export$505240e540ebe25[size];
    let t6;
    if ($[2] !== color || $[3] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: t5,
            fill: color,
            stroke: color,
            strokeWidth: $71771e95bc58fd84$var$OUTLINE_WIDTH * 2
        });
        $[2] = color;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== height || $[6] !== t4 || $[7] !== t6 || $[8] !== width) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            display: "block",
            width: width,
            height: height,
            viewBox: t4,
            overflow: "visible",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            focusable: "false"
        }, t6);
        $[5] = height;
        $[6] = t4;
        $[7] = t6;
        $[8] = width;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: t2,
            "data-testid": testId,
            "aria-hidden": "true",
            className: t3
        }, t7);
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
module.exports["AGENT_AVATAR_SHELL_SIZE"] = $71771e95bc58fd84$export$d825e67f4012c870;
module.exports["AGENT_AVATAR_SHELL_VIEWBOX"] = $71771e95bc58fd84$export$ce24d36f8c4f7527;
module.exports["AGENT_AVATAR_SHELL_PATH"] = $71771e95bc58fd84$export$505240e540ebe25;
module.exports["AgentPresenceOutline"] = $71771e95bc58fd84$export$8b63d3e9f6d12780;

});

parcelRegister("c6zRP", function(module, exports) {
const $49bfa46c557a50ec$export$64cd126c152ef69d = 30000;
const $49bfa46c557a50ec$export$f1e7f4004cc0d32 = $49bfa46c557a50ec$export$64cd126c152ef69d + 300000;
const $49bfa46c557a50ec$var$hasValidLastActive = (lastActive)=>typeof lastActive === 'number' && Number.isFinite(lastActive);
const $49bfa46c557a50ec$export$545448b69b42d8b = (agent, now = Date.now())=>{
    if (!$49bfa46c557a50ec$var$hasValidLastActive(agent.lastActive)) return 'active';
    const age = now - agent.lastActive;
    if (age >= $49bfa46c557a50ec$export$f1e7f4004cc0d32) return 'expired';
    if (age >= $49bfa46c557a50ec$export$64cd126c152ef69d) return 'inactive';
    return 'active';
};
const $49bfa46c557a50ec$export$70aa8e977829b349 = (lastActive, now = Date.now())=>{
    if (!$49bfa46c557a50ec$var$hasValidLastActive(lastActive)) return undefined;
    const inactiveAt = lastActive + $49bfa46c557a50ec$export$64cd126c152ef69d;
    if (inactiveAt > now) return inactiveAt;
    const expiresAt = lastActive + $49bfa46c557a50ec$export$f1e7f4004cc0d32;
    return expiresAt > now ? expiresAt : undefined;
};
const $49bfa46c557a50ec$export$f262baf6c8c08ca8 = (agent)=>$49bfa46c557a50ec$export$545448b69b42d8b(agent) !== 'active';
module.exports["getAgentPresenceStatus"] = $49bfa46c557a50ec$export$545448b69b42d8b;
module.exports["getNextAgentPresenceBoundary"] = $49bfa46c557a50ec$export$70aa8e977829b349;
module.exports["isAgentPresenceInactive"] = $49bfa46c557a50ec$export$f262baf6c8c08ca8;

});

parcelRegister("hlpSM", function(module, exports) {
const $1c7976239f2020c5$export$454786137388d58b = ({ id: id, actingUserId: actingUserId, includeActingUser: includeActingUser = false })=>includeActingUser && actingUserId ? `${id}:${actingUserId}` : id;
module.exports["getAgentPresenceKey"] = $1c7976239f2020c5$export$454786137388d58b;

});


//# sourceMappingURL=AgentPresence.a225116b.js.map
